import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";


// const DataFormatter = (number) => {
//   if (number >= 10000000) {
//     // Greater than or equal to 1 Crore
//     return (number / 10000000).toFixed(2) + 'Cr';
//   } else if (number >= 100000) {
//     // Greater than or equal to 1 Lakh
//     return (number / 100000).toFixed(2) + 'L';
//   } else if (number >= 1000) {
//     // Greater than or equal to 1 Thousand
//     return (number / 1000).toFixed(2) + 'K';
//   } else {
//     // Less than 1 Thousand
//     return number.toString();
//   }
// };
const DataFormatter = (value) => {
  const totalSeconds = Math.round(value * 60);
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;

  if (totalSeconds < 60) return `${s}s`;
  if (totalSeconds < 3600) return `${m}m ${s > 0 ? `${s}s` : ''}`;
  return `${h}h ${m > 0 ? `${m}m` : ''}`;
};

const Chart = ({ data }) => {
  return (
    <>
      <ResponsiveContainer>
        <AreaChart
          strokeWidth={3}
          width={600}
          height={240}
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="colorUvs" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#8884d8" stopOpacity={0.5} />
              <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="colorPvs" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#82ca9d" stopOpacity={0.5} />
              <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
            </linearGradient>

            <linearGradient id="colorUvStroke" x1="50%" y1="100%" x2="0" y2="1">
              <stop offset="0%" stopColor="#8884d8" stopOpacity={1} />
              <stop offset="100%" stopColor="#8884d8" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="colorPvStroke" x1="50%" y1="100%" x2="0" y2="1">
              <stop offset="0%" stopColor="#82ca9d" stopOpacity={1} />
              <stop offset="100%" stopColor="#82ca9d" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="name" strokeWidth={0} tick={{ color: "red" }} />
          <YAxis axisLine={false} tickFormatter={DataFormatter} />
          <CartesianGrid
            stroke="#efefef"
            strokeWidth={2}
            vertical={false}
            strokeDasharray="7 10"
          />
          {/* <Tooltip /> */}
          <Tooltip
            formatter={(value, name) => {
              let formatted = '';
              if (name == "Timer") {

                const totalSeconds = Math.round(value * 60);
                const h = Math.floor(totalSeconds / 3600);
                const m = Math.floor((totalSeconds % 3600) / 60);
                const s = totalSeconds % 60;

                if (totalSeconds < 60) formatted = `${s}s`;
                else if (totalSeconds < 3600) formatted = `${m}m ${s > 0 ? `${s}s` : ''}`;
                else formatted = `${h}h ${m > 0 ? `${m}m` : ''}`;
              } else {
                formatted = value;
              }

              return [formatted, name];
            }}
          />
          <Area
            type="monotone"
            dataKey="Timer"
            stroke="url(#colorPvStroke)"
            strokeId={3}
            fillOpacity={0.5}
            fill="url(#colorPvs)"
          />
          <Area
            type="monotone"
            dataKey="Task"
            stroke="url(#colorUvStroke)"
            strokeId={3}
            fillOpacity={0.5}
            fill="url(#colorUvs)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </>
  );
};

export default Chart;
